import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import CustomAddPage from '../../../components/CustomComponents/CustomAddPage'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useStore } from '../../../hooks/CompanyConfiguration/useStore'
import { useAuditTask } from '../../../hooks/Others/Audit/useAuditTask'
import { useTasks } from '../../../hooks/Others/Audit/useTask'
import { sortByName } from '../../../shared/constants'
import { selectDropdown } from '../../../utils/otherHelper'
import { useHistory } from 'react-router-dom'
export default function AddPosTask({ task }) {
  const [taskData, setTaskData] = useState({
    name: '',
    active: true,
    description: '',
    taskType: '',
    store: '',
    task: '',
    startDate: new Date().toISOString(),
    closureDate: moment().add(7, 'days').toISOString(),
  })

  const { loading, getAllTask } = useTasks()
  const { addTask, updateAuditTask } = useAuditTask()
  const { getAllStore } = useStore()
  const history = useHistory()

  const { tasks } = useContext(OtherContext)
  const tempTask = tasks && tasks.filter((val) => val && val.taskType === 'POS')
  const { stores } = useContext(ConfigurationContext)
  const handleTask = () => {
    if (task) {
      updateAuditTask({ ...taskData, taskId: task._id })
      history.push('/pos-tasks')
    } else {
      addTask(taskData)
      history.push('/pos-tasks')
    }
  }

  useEffect(() => {
    getAllStore()
    getAllTask()
  }, [])
  useEffect(() => {
    if (task) {
      setTaskData({
        ...task,
        task: task.task && task.task._id,
        store: task.store && task.store._id,
        startDate: task.createdDate,
      })
    }
  }, [task])

  const data = [
    { label: 'Event', value: taskData.name, name: 'name' },
    { label: 'Store', value: taskData.store, name: 'store', options: sortByName(stores), ...selectDropdown },
    { label: 'Assign Task', value: taskData.task, name: 'task', options: sortByName(tempTask), ...selectDropdown },
    { label: 'Start Date', value: taskData.startDate, name: 'startDate', type: 'DATE' },
    { label: 'End Date', value: taskData.closureDate, name: 'closureDate', type: 'DATE' },
    { label: 'Description', value: taskData.description, name: 'description', grid: 12 },
  ]

  return <CustomAddPage heading="POS Task" redirect="ALL_POS_TASK" currentData={task} loading={loading} state={taskData} setState={setTaskData} handleClick={handleTask} inputFields={data} />
}
